import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";

const Main = lazy(() => import("../components/nomination/nominationDetails"));

const NominationDetails = () => {
  return (
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
  );
};

export default NominationDetails;